import Button from "components/common/Button/Button";
import * as React from "react";
import OnboardingContainer from "screens/Onboarding/Onboarding.container";

const LogoutButton = ({ callback }) => {
  const { logoutCustomer } = OnboardingContainer.useContainer();

  const handleLogout = () => {
    callback();
    logoutCustomer();
  };
  return (
    <Button tertiary onClick={handleLogout} style={{ marginTop: "5rem" }}>
      Go to Home screen
    </Button>
  );
};

export default LogoutButton;



// WEBPACK FOOTER //
// ./src/components/Gates/LockScreen/LogoutButton.tsx